export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10931.77f51e87.jpg";